<template>
  <div>
    <preamble v-bind="preamble" />
    <section class="main">
        <div class="container">
            <div class="columns quiz">
                <div class="column is-8 is-offset-2">
                    <div v-if="!resetQuiz" class="columns">
                        <div class="column is-12">
                          <div class="columns">
                              <div class="column is-6" v-for="(singleCase, index) in getCase" :key="index">
                                  <div @click="handleNextCase(index)" class="question" v-bind:class="{'isselected' : isSelected}">
                                    <div v-if="isSelected && singleCase.correct === true" class="maker green">
                                      <div class="maker-true">
                                        <span>
                                          <svg height="13" width="16"><path d="M14.293.293l1.414 1.414L5 12.414.293 7.707l1.414-1.414L5 9.586z"></path></svg>
                                        </span>
                                      </div>
                                    </div>
                                    <div v-if="isSelected && !singleCase.correct" class="maker">
                                      <div class="maker-false">
                                        <span>
                                          <svg height="13" width="16"><path d="M12.8,0.4l1.4,1.4L3.5,12.5l-1.4-1.4l1.4-1.4l0,0L12.8,0.4z"/><path d="M14.1,11.2l-1.4,1.4L2,1.9l1.4-1.4l1.4,1.4l0,0L14.1,11.2z"/></svg>
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                        <span v-if="index < 1" class="key-helper">A</span>
                                        <span v-if="index > 0" class="key-helper">B</span>
                                        <h4>{{ singleCase.text }}</h4>
                                    </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div v-if="resetQuiz" class="columns">
                        <div class="column is-12">
                          <div class="columns quiz-wrapper">
                            <div class="column is-8">
                              <div class="chapter">
                                  <div>
                                      <h4 class="thankyou">Thank you for taking the quiz!</h4>
                                      <p>Which of these are you most likely to do:</p>

                                      <label v-for="(item, index) in likeyToDo" :key="index" :for="index" class="checkbox">
                                        <input :id="index" :value="item" type="checkbox" v-model="checkedLikeyToDo">
                                          {{item}}
                                      </label>

                                  </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="score">
                                <span>
                                  {{ correctItems }}/{{cases.length}}
                                </span>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column is-3">
                          <a v-if="!resetQuiz" @click="nextCase" class="submit-button button is-black is-fullwidth is-medium">
                            Next Case
                          </a>
                          <a v-if="resetQuiz" @click="handleResetQuiz" class="submit-button button is-fullwidth is-medium">
                            Submit & Reset
                          </a>
                      </div>
                      <div class="column is-9">
                          <div class="q-count">
                            <span class="q-percentage">{{ selectedItems.length }} of {{ cases.length }} answered</span>
                            <span class="q-progress"></span>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
    import Preamble from '@/components/Preamble.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import {  resources } from '@/utils/constants'
    import { quizCases } from '@/utils/quizCases'

    export default {
        name: "Quiz",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble,    
                },
        data() {
            return {
              quiz: {},
              cases: quizCases,
              caseIndex: 0,
              isSelected: false,
              selectedItems: [],
              correctItems: 0,
              resetQuiz: false,
              checkedLikeyToDo: [],
              likeyToDo: ['Go for an HIV test', 'Always use a condom', 'Donate funds to HIV/ AIDS work', 'Take my HIV medication', 'Being more open about my HIV/AIDS status'],
              preamble: {
                title: 'Quiz',
                subTitle: '...',
                description: '',
                watchVideo: '',
              },
            }
        },
        created() {

          this.read(`${resources.quiz}`)
                    .then(response => {
                    this.quiz = response.data[0]

                    this.preamble = {
                            title: this.quiz.title, 
                            subTitle: this.quiz.tagLine,
                            description: this.quiz.shortDescription,
                        }
                })

        },
        mounted() {
            //console.log(this.cases)
        },
        methods: {
          nextCase() {
            this.isSelected = false
            if((this.caseIndex + 1) < this.cases.length) {
              this.caseIndex ++;
            } else {
              this.resetQuiz = true
            }
            
          },
          handleNextCase(selected) {
            if(selected || selected === 0) {
              this.isSelected = true
            }
            if(this.selectedItems.length < this.cases.length){
              if(this.cases[this.caseIndex][selected].correct){
                this.correctItems ++
              }
              this.selectedItems.push(this.cases[this.caseIndex][selected])
            }
            //this.nextCase()
            setTimeout(() => this.nextCase(), 1500);
          },
          handleResetQuiz() {

            this.handleSubmitResults()
            this.resetQuiz = false
            this.correctItems = 0
            this.caseIndex = 0
            this.selectedItems = []
          },
          handleSubmitResults() {
            let finalAnswers = ''

            this.selectedItems.forEach(answer => {
              if(answer.correct) {
                answer = `<p>${answer.text}</p>`
              } else {
                answer = `<p><s>${answer.text}</s></p>`
              }

              finalAnswers += answer
            });

            let finalLikeyToDo = ''
            this.checkedLikeyToDo.forEach(item => {
              finalLikeyToDo += `${item}, `
            })

            let score = `${this.correctItems}/${this.cases.length}`

            let quizPayload = {"type": [{"target_id": "quiz","target_type": "node_type"}],
                                            "title": [{"value": `${score}`}],
                                            "field_answers": [{"value": `${finalAnswers}`}],
                                            "field_likelytodo": [{"value": `${finalLikeyToDo}`}]}

                this.create(resources.nodeEntity, quizPayload)
                  .then( console.log('Submitted') )
          },

          closePop() {
            this.popContent.triggered = false;
          }
        },
        computed: {
             getCase() {
               return this.cases[this.caseIndex]
             }
        },
    }
</script>

<style>
</style>
